import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  units = ['Bytes', 'kB', 'MB', 'GB'];

  transform(value: number): string {
    if(typeof value !== 'number') return null;
    var index = 0;
    while(value > 999){
      value /= 1000;
      index++;
    }
    return `${value.toFixed(2)} ${this.units[index]}`;
  }

}
